export default {
  setLang(state, data) {
    if(state.lang !== data){
      state.lang = lang
    }
    localStorage.setItem('LANG' , state.lang)
  },
  addLangPack(state, data) {
    if (data) {
      state.langPack.push(data)
    }
  },
  setMenu(state, data) {
    if(data){
      state.currentMenu = data
    }
  },
  setTheme(state , data){
    if(state.theme == 'light'){
      state.theme = 'dark'
    }else if(state.theme == 'dark'){
      state.theme = 'ios'
    }else if(state.theme == 'ios'){
      state.theme = 'light'
    }
    localStorage.setItem('THEME' , state.theme)
  },
  setAutoSignin(state , data){
    state.autoSignin = !!data
    localStorage.setItem('AUTOSIGNIN' , state.autoSignin)

  }
}
